import { render, staticRenderFns } from "./batch-add-vehicle-info-business-note-modal.vue?vue&type=template&id=2224c99d"
import script from "./batch-add-vehicle-info-business-note-modal.vue?vue&type=script&lang=js"
export * from "./batch-add-vehicle-info-business-note-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports